import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { GatewayService } from 'src/app/gateway.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-diario',
  templateUrl: './diario.component.html',
  styleUrls: ['./diario.component.scss']
})
export class DiarioComponent implements OnInit {

  diarioColumns: string[] = ['DIA', 'MES', 'ANIO', 'REGISTROS', 'CONTACTABILIDAD', 'CONVERSION', 'EFECTIVIDAD', 'VPH'];
  dataSource = new MatTableDataSource<any>([]);
  public campana={nombre:'',idcampana:''};

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private localsave: LocalSaveService,
    private gateway: GatewayService
  ) { }

  ngOnInit() {
    this.campana = this.localsave.get('supervisorcampana');
    this.loaddias();
  }

  loaddias() {
    this.spinner.show();
    this.gateway.get('diacampana', { IDCAMPANA: this.campana.idcampana }).then((result: any) => {
      this.dataSource = new MatTableDataSource(result.rows);
      this.spinner.hide();
    }
    ).catch(function (e) {
    });
  }

  reload(){
    this.loaddias();
  }

  back() {
    this.router.navigate(['home/monitorcampana'])
      .then((e) => {
      });
  }

  descargaExcel(){

    let datareport = [];
    this.spinner.show();
    let campana = this.localsave.get('supervisorcampana');
    this.gateway.get('diacampana', { IDCAMPANA: this.campana.idcampana }).then((result: any) => {
      datareport = result.rows;

      datareport.forEach(function(currentItem) {
        delete currentItem['idagente'];

        Object.defineProperty(currentItem, 'Nombre',Object.getOwnPropertyDescriptor(currentItem, 'nombre')); 
        delete currentItem['nombre'];
        
        Object.defineProperty(currentItem, 'Dia',Object.getOwnPropertyDescriptor(currentItem, 'diagestion')); 
        delete currentItem['diagestion'];   

        Object.defineProperty(currentItem, 'Mes',Object.getOwnPropertyDescriptor(currentItem, 'mesgestion')); 
        delete currentItem['mesgestion'];   

        Object.defineProperty(currentItem, 'Año',Object.getOwnPropertyDescriptor(currentItem, 'aniogestion')); 
        delete currentItem['aniogestion'];

        Object.defineProperty(currentItem, 'Registros',Object.getOwnPropertyDescriptor(currentItem, 'registros')); 
        delete currentItem['registros'];

        Object.defineProperty(currentItem, 'VPH',Object.getOwnPropertyDescriptor(currentItem, 'vph')); 
        delete currentItem['vph'];

        Object.defineProperty(currentItem, 'Contactabilidad',Object.getOwnPropertyDescriptor(currentItem, 'contactabilidad')); 
        delete currentItem['contactabilidad'];

        Object.defineProperty(currentItem, 'Conversion',Object.getOwnPropertyDescriptor(currentItem, 'conversion')); 
        delete currentItem['conversion'];

        Object.defineProperty(currentItem, 'Efectividad',Object.getOwnPropertyDescriptor(currentItem, 'efectividad')); 
        delete currentItem['efectividad'];
      });
      //console.log(datareport)
      const fileName = 'Reporte_diario_'+campana.nombre+'_'+ Date.now();
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datareport);
      XLSX.utils.book_append_sheet(wb, ws);

      const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
      this.spinner.hide();
    }
    ).catch(function (e) {
    });

  }

}
